
import ProductCategories from '@/graphql/queries/taxonomies/ProductCategories'

export default {
  vessel: {
    title: {
      fontSize: '3xl',
      textColor: 'black'
    }
  },
  async fetch() {
    const { data } = await this.$graphql.query({
      clientId: 'eshop',
      query: ProductCategories,
      variables: {
        where: { kind: 'category' },
        children: { activeProducts_is_null: false }
      }
    })

    this.categories = data.categories.nodes
  },
  data() {
    return {
      categories: null,
      columns: { all: 2, md: 3, lg: 4, xl: 5 }
    }
  }
}
